import { styled } from 'stitches.config'
import { FooterRoot } from 'components/Footer/Footer.styles'
import { Card } from 'components/Card'

export const CheckoutLayoutRoot = styled('div', {
  backgroundColor: '$secondary-100',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '0',

  '&': {
    [`${FooterRoot}`]: {
      borderTop: '12px solid transparent',
      borderBottom: 0,
      borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

      '@bp2': {
        borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
      },
    },
  },

  '@bp2': {
    paddingTop: 0,
  },
})

export const Wrapper = styled('div', {
  position: 'relative',
  backgroundColor: '$secondary-100',
  px: '$3',
  paddingTop: '$2',
  paddingBottom: '$10',
  maxWidth: '$max',
  margin: 'auto',

  '@bp2': {
    px: '$7',
    $$headerHeight: '80px',
    paddingTop: '$8',
    backgroundImage:
      'url(assets/pattern-all-products-01.png), url(assets/pattern-all-products-02.png)',
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundPosition: 'bottom left, top right',
    backgroundSize: '484px, 484px',
  },

  variants: {
    hideBackgroundPatterns: {
      true: {
        backgroundImage: 'none',
      },
    },
  },
})

export const BackButton = styled('a', {
  cursor: 'pointer',
  color: '$primary-800',
  alignSelf: 'flex-start',
  display: 'flex',
  alignItems: 'center',
})

export const CardContainer = styled('div', {
  width: '100%',

  '@bp2': {
    px: '$8',
  },
})

export const MealPlanCheckoutCard = styled(Card, {
  padding: '$3',
  position: 'relative',

  '@bp2': {
    padding: '$10',
  },
})
